/* eslint-disable jsx-a11y/alt-text */
import { cardiver } from "../assets";

const Cardoverlay = () => {

  return (
    <>
      <div  className="modal fade" id="cardOverlay" tabIndex="-1" aria-labelledby="cardOverlayModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <div className="backcardlay">
                <div className="container">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <div className="card overlay-card ">
                      <header className="overlay-header"></header>
                      <div className="text-center mt-5">
                        <h3 className="mt-4 overlay-font-mobile w-76 m-auto color-mistake-pay memphis-medium">
                          The bank makes a mistake on your account pay $15
                        </h3>
                      </div>
                      <div className="text-center mt-4 ">
                        <h5 className="text-center text-color-brown mt-3 Pacifico-Regulars">
                          lose <img src={cardiver} className="width-set-lay" />{" "}
                          money/debt
                        </h5>
                      </div>
                      <div className="mt-4">
                        <footer className="overlay-footer mt-5">
                          <div className="mt-5 heath-bottom-footer">
                            <h6 className="text-right text-white mr-3 health-bootom-over memphis-medium font-economy">
                            &copy;<span className="ml-1">Health Economy 2019</span>
                            </h6>
                          </div>
                        </footer>
                      </div>
                    </div>
                  </div>
                </div>
              </div>              
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cardoverlay;
